import store from '@/state/store'
const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

const deliveryNoteFields = [
  {
    name: 'note',
    key: 'note',
    label: 'Catatan Pengiriman',
    placeholder: 'Catatan Pengiriman',
    isSortable: true,
    isEditable: true,
    validation: "required|max:255,length",
  },
  {
    name: 'attachment',
    key: 'attachment',
    label: 'Unggah Dokumen',
    placeholder: 'Tidak ada dokumen terpilih',
    isSortable: false,
    isEditable: true,
    type: 'file-input',
    buttonText: 'Pilih dokumen',
    maxSize: 2,
    accept: '.jpg,.jpeg,.png,.pdf',
    getFile: {
      nameKey: 'document_attachment_file_name',
      urlKey: 'document_attachment_url'
    },
    storeFile: {
      nameKey: 'document_attachment_file_name',
      base64Key: 'document_attachment'
    },
    thStyle: 'width: 50%',
  }
]

export default deliveryNoteFields
